<template>
  <!-- 用户授权书 -->
  <div class="my-agree">
    <div class="right-box">
      <p class="title">使用条款</p>
      <div class="cons">
        <p class="txt">尊敬的用户，欢迎使用iEP!</p>
        <p class="txt">由于需求的拓展以及合规要求，制定了以下协议，以帮助您了解您享有的相关权利。请您认真阅读下列链接中载明的全部协议条款。若您已完整阅读并同意下述内容，请在左侧勾选同意框。</p>
      </div>
      <template v-if="isShowAgree">
        <van-checkbox class="checkbox" icon-size="18px" v-model="checked1" checked-color="#EB1700" shape="square">
          <span class="label-txt">已阅读并同意</span>
          <span class="square-txt">
            <span v-if="isShowAgree.includes('1')" @click.stop="handleClickGo('UserAgreement')">《iEP用户协议》</span>
            <span v-if="isShowAgree.includes('2')" @click.stop="handleClickGo('POWER')">《隐私声明》</span>
          </span>
        </van-checkbox>
        <van-checkbox class="checkbox" v-if="isShowAgree.includes('3') && `${userInfo.memberType}` === '0'" icon-size="18px" v-model="checked2" checked-color="#EB1700" shape="square">
          <span class="label-txt">已阅读并同意</span>
          <span class="square-txt" @click.stop="handleClickGo('RemoteTeaching')">《远程带教协议》</span>
        </van-checkbox>
      </template>
      <div class="mt20 agree_btn" :class="!checked1 ? 'noActive' : ''" @click="handleChange">
        同意并继续
      </div>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { checkAgreeUserOk } from '@/api/api'
import { beforeLoginFun } from '@/utils/util'
import { addUserhospauth } from '@/api/person'
const UserProfile = {
  name: 'agree',
  data() {
    return {
      checked: false,
      dataResult: {},
      valuetxt: '',
      timetxt: '',
      show: false,
      checked1: false,
      checked2: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    isUserInfo() {
      return this.$route.query.isUserInfo
    },
    isAgree() {
      return this.$route.query.isAgree
    },
    isShowAgree() {
      if (sessionStorage.getItem('iepLoginResult')) {
        const iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
        if (iepLoginResult.isShowAgree) {
          return iepLoginResult.isShowAgree.split('_')
        }
      } else {
        return []
      }
    }
  },
  mounted() {
  },
  methods: {
    handleClickGo(type) {
      const obj = {
        path: '/agreeDetailPage',
        query: {}
      }
      switch (type) {
        case 'UserAgreement':
          obj.query.typeArgee = 'UserAgreement'
          break
        case 'POWER':
          obj.query.typeArgee = 'POWER'
          break
        case 'RemoteTeaching':
          obj.query.typeArgee = 'RemoteTeaching'
          break
      }
      this.$router.push(obj)
    },
    handleRemote () {
      addUserhospauth({
        hospital: this.userInfo.hospitalName,
        hospitalCustCd: this.userInfo.hospitalId,
        veevaMultiCode: this.userInfo.multiCode,
        authStatus: 1,
        userId: this.userInfo.id,
      }).catch()
    },
    goAuthRedirectTarget() {
      const shareUrl = this.$route.query.shareUrl
      if (shareUrl) {
        let raw = shareUrl
        try {
          if (raw.indexOf('http://') !== 0 && raw.indexOf('https://') !== 0) {
            raw = window.atob(raw)
          }
        } catch (e) {
          raw = ''
        }
        const bingliUrl = process.env.bingliUrl || ''
        if (raw && bingliUrl && raw.indexOf(bingliUrl) === 0) {
          window.location.href = raw
          return true
        }
      }
      const redirectURL = localStorage.getItem('redirectURL')
      if (!redirectURL) return false
      if (redirectURL.indexOf('/register') > -1 || redirectURL.indexOf('/loginPage') > -1 || redirectURL.indexOf('longTimeLogin') > -1) {
        return false
      }
      const hrefTxt = redirectURL.indexOf('/journeymob') > -1
        ? redirectURL.substring(11)
        : redirectURL
      localStorage.removeItem('redirectURL')
      if (hrefTxt.indexOf('http://') === 0 || hrefTxt.indexOf('https://') === 0) {
        window.location.href = hrefTxt
        return true
      }
      this.$router.push({ path: hrefTxt })
      return true
    },
    handleChange() {
      if (!this.checked1) {
        this.$toast('请先勾选隐私协议！')
        return
      }
      checkAgreeUserOk(this.userInfo.id, this.isShowAgree && this.isShowAgree.length ? this.isShowAgree.join('_') : '')
        .then((res) => {
          if (res.code === 0) {
            let iepLoginResult = JSON.parse(sessionStorage.getItem('iepLoginResult'))
            iepLoginResult.isAgree = '1'
            if (this.checked2) {
              this.handleRemote()
            }
            sessionStorage.setItem('iepLoginResult', JSON.stringify(iepLoginResult))
            // const { backurl } = iepLoginResult
            // if (backurl) {
            //   window.location.href = atob(backurl)
            //   return
            // }
            if (this.goAuthRedirectTarget()) {
              return
            }
            beforeLoginFun()
          } else {
            this.$router.push({
              path: '/home'
            })
          }
        })
        .catch((err) => {
          console.error(err)
          this.$router.push({
            path: '/home',
          })
        })
    },
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-agree {
  background: url("../../assets/images/person/agree.png") no-repeat center
    center / 100% 100%;
  width: 100%;
  height: 148px;
  padding-top: 148px;
  box-sizing: border-box;
  .auth {
    text-align: right;
    padding: 20px;
    box-sizing: border-box;
    .txt-auth {
      display: block;
      line-height: 32px;
      .txt-line {
        padding-bottom: 2px;
        border-bottom: 1px solid #000;
      }
    }
  }
  .right-box {
    padding: 0 32px;
    box-sizing: border-box;
    .title {
      font-family: PingFang HK, PingFang HK;
      font-weight: 600;
      font-size: 24px;
      color: #1a1a1a;
      text-align: center;
      margin-bottom: 10px;
    }
    .txt {
      color: rgba(0,0,0,0.6);
      line-height: 20px;
      margin-bottom: 8px;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN;
    }
    .checkbox {
      margin-top: 16px;
      .label-txt {
        color: #000000;
        font-family: PingFang SC, PingFang SC;
        font-style: normal;
        font-size: 14px;
      }
      .square-txt {
        color: #EB1700;
        font-family: PingFang SC, PingFang SC;
        font-style: normal;
        font-size: 14px;
      }
    }
    .agree_btn {
      margin: 20px auto;
      width: 100%;
      height: 42px;
      background: #EB1700;
      border-radius: 100px;
      font-family: Helvetica, Helvetica;
      font-weight: 400;
      font-size: 16px;
      color: #fff;
      line-height: 42px;
      text-align: center;
    }
    .van-radio--horizontal {
      margin-right: none !important;
    }
    .noActive {
      background: rgba(0,0,0,0.08);;
      color: #7A8494;
      pointer-events: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/agree.vue